import { mapState, mapActions } from 'vuex';

export const utilities = {
	computed: {
		...mapState([
			'backgroundColor',
			'currentKey',
			'endRound',
			'endGame',
			'difficult',
			'gamemode',
			'isPreCounting',
			'soundsStatus',
			'sounds'
		]),
	},
	methods: {
		...mapActions(['updateProperty','getWordsByCategories','pickRandomWords','prepareMatchUrl','expandAllWords','resetAllCards']),
			getWordsByCategories(dictionary, numOfWords, categories, exclusions){
				let words = [];
				if(categories.length){
					dictionary = dictionary.filter(el => {
						let found = false;
						for(let i = 0, j = categories.length; i<j; i++){
							if(el.category.includes(categories[i])) found = true;
						}
						return found;
					});
				}
				
				for(let i = 0; i < numOfWords; i++){
					let randomIndex = Math.round(Math.random()*(dictionary.length-1));
					let word = dictionary.splice(randomIndex,1)[0];
					while(exclusions.includes(word.word)){
						randomIndex = Math.round(Math.random()*(dictionary.length-1));
						word = dictionary.splice(randomIndex,1)[0];
					}
					words.push(word.word.toLowerCase());
					exclusions.push(word.word);
				}
				let fullWords = [];
				for(let i = 0; i < numOfWords; i++){
					fullWords.push([words[i]]);
				}
				return fullWords;
			},
			async handleFetchErrors(response){
				if (!response.ok) throw Error(response.statusText);
				return response;
			},
			pickRandomWords(){
				let dictionary = this.$store.state.dictionary,
					exclusions = [];

				// Subject 1
				// Is
				let words = this.getWordsByCategories(dictionary, 2, ['N','A'], exclusions);
				this.$store.state.words.subject_1.is = words;
				
				// Says
				words = this.getWordsByCategories(dictionary, 2, [], exclusions);
				this.$store.state.words.subject_1.says = words;
				
				// Does
				words = this.getWordsByCategories(dictionary, 2, ['V','B'], exclusions);
				this.$store.state.words.subject_1.does = words;

				// Subject 2
				// Is
				words = this.getWordsByCategories(dictionary, 2, ['N','A'], exclusions);
				this.$store.state.words.subject_2.is = words;
				
				// Says
				words = this.getWordsByCategories(dictionary, 2, [], exclusions);
				this.$store.state.words.subject_2.says = words;
				
				// Does
				words = this.getWordsByCategories(dictionary, 2, ['V','B'], exclusions);
				this.$store.state.words.subject_2.does = words;
				
				// Context
				words = this.getWordsByCategories(dictionary, 2, ['A'], exclusions);
				this.$store.state.words.context.place = words;

				words = this.getWordsByCategories(dictionary, 2, ['B'], exclusions);
				this.$store.state.words.context.time = words;

				// Expressions
				words = this.getWordsByCategories(dictionary, 2, ['E'], exclusions);
				this.$store.state.words.expressions.expressions = words;

				this.expandAllWords();
				
				return this.prepareMatchUrl();
			},
			async expandWordFromSource(word,source){
				let currentWords = [word];
				if(source){
					const response = await fetch('words/'+word+'.txt');
					const text = await response.text();
					if(text && !text.includes('html')){
						text.split("\n").forEach(line=>{
							if(line.length>0) currentWords.push(line);
						})
					}
				}
				return currentWords;
			},
			prepareMatchUrl(){
				let base = location.origin+location.pathname + '#/gioca/?difficulty='+this.$store.state.difficulty+'&words=';
				let words = this.$store.state.words;
				console.log(JSON.stringify(words));

				return base + btoa(unescape(encodeURIComponent(JSON.stringify(words))));
			},
			async expandAllWords(){
				for(let card in this.$store.state.words){
					let cardContent = this.$store.state.words[card];
					for(let wordGroup in cardContent){
						for(let i = 0, j = cardContent[wordGroup].length; i < j; i++){
							for(let l = 0, m = cardContent[wordGroup][i].length; l < m; l++){
								let word = this.$store.state.words[card][wordGroup][i][l];
								let wordInDictionary = this.$store.state.dictionary.find(el => {
									return el.word == word;
								});
								this.$store.state.words_extended[card][wordGroup][i] = await this.expandWordFromSource(word,wordInDictionary && wordInDictionary.source>0);
							}
						}
					}
				}
			},
			resetSingleCard(card){
				let cardContent = this.$store.state.words[card];
				for(let wordGroup in cardContent){
					for(let i = 0, j = cardContent[wordGroup].length; i < j; i++){
						this.$store.commit('updateFoundWord',{
							property: {
								card: card,
								wordGroup: wordGroup,
								index: i
							},
							value: false
						})
					}
				}
				this.$store.commit('updateFoundCard',{
					property: card,
					value: false
				})
			},
			resetAllCards(){
				this.resetSingleCard('subject_1');
				this.resetSingleCard('subject_2');
				this.resetSingleCard('context');
				this.resetSingleCard('expressions');
				this.$store.state.text = '';
			},
			checkCompletedCard(card){
				let cardContent = this.$store.state.foundWords[card],
					total = 0,
					found = 0;
				for(let wordGroup in cardContent){
					for(let i = 0, j = cardContent[wordGroup].length; i < j; i++){
						total++;
						if(cardContent[wordGroup][i]) found++;
					}
				}
				this.$store.commit('updateFoundCard',{
					property: card,
					value: total==found
				})	
			}
		},
		
};
